import { Css, Filters, Switch, usePersistedFilter } from "@homebound/beam";
import { Fragment } from "react";
import { useToggle } from "src/hooks";
import { SingleStageFilter, useProjectStageSingleFilter } from "src/hooks/useProjectStageSingleFilter";
import { useRouteParams } from "src/hooks/useRouteParams";
import { useStripStage } from "src/hooks/useStripStage";
import { PageHeader } from "src/routes/layout/PageHeader";
import { TableActions } from "src/routes/layout/TableActions";
import { useProjectContext } from "src/routes/projects/context/ProjectContext";
import { ProjectParams } from "src/routes/routesDef";
import { HomeownerContractsTable } from "./components/HomeownerContractsTable";

export function HomeownerContractsPage() {
  useStripStage();
  const { projectId } = useRouteParams<ProjectParams>();
  const { __typename, clientContract, latestActiveStage } = useProjectContext();
  const { filterDefs } = useProjectStageSingleFilter(latestActiveStage);
  const [showSharedCosts, toggleSharedCosts] = useToggle(false);
  const { setFilter, filter } = usePersistedFilter<SingleStageFilter>({ storageKey: "changeEventsFilter", filterDefs });

  return (
    <Fragment>
      <PageHeader title={__typename === "StandaloneProject" ? `${clientContract}s` : "Client Contracts"} />
      <TableActions>
        <Filters<SingleStageFilter> filter={filter} filterDefs={filterDefs} onChange={setFilter} />
      </TableActions>
      <div css={Css.pb2.$}>
        <Switch label="Show Shared Costs" compact selected={showSharedCosts} onChange={toggleSharedCosts} />
      </div>
      <HomeownerContractsTable projectId={projectId} filter={filter} showSharedCosts={showSharedCosts} />
    </Fragment>
  );
}
